import { Box, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import StatusBadge from "../../../../components/StatusBadge"

const ResumoConsolidadoStatus = ({ date }) => {
    const [rows, setRows] = useState([])

    useEffect(() => {
        loadMockData()
    }, [date])

    const loadMockData = () => {
        const payload = {
            caracteristicas: {
                EmAndamento: 37,
                EmProducao: 359,
                Excluidos: 6,
                Total: 402,
            },
            Eventos: {
                EmAndamento: 4,
                EmProducao: 6,
                Excluidos: 2,
                Total: 12,
            },
        }

        const formatted = [
            {
                id: 1,
                categoria: "Características",
                ...payload.caracteristicas,
            },
            {
                id: 2,
                categoria: "Eventos",
                ...payload.Eventos,
            },
        ]

        setRows(formatted)
    }

    const renderItem = (value, label, color) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <StatusBadge
                label={value}
                width={100}
                radius={1}
                backgroundColor={color}
                fontColor="common.white"
            />
            <Typography variant="body2" color="common.white">
                {label}
            </Typography>
        </Box>
    )

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {rows.map((row) => (
                <Box
                    key={row.id}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 3,
                    }}
                >
                    {/* Nome */}
                    <Typography
                        sx={{
                            minWidth: 140,
                            fontWeight: 500,
                        }}
                        color="common.white"
                    >
                        {row.categoria}
                    </Typography>

                    {/* Status */}
                    {renderItem(row.EmAndamento, "Em andamento", "warning.main")}
                    {renderItem(row.EmProducao, "Em produção", "#2BCE95")}
                    {renderItem(row.Excluidos, "Excluídos", "error.main")}
                    {renderItem(row.Total, "Total", "grey.700")}
                </Box>
            ))}
        </Box>
    )
}

ResumoConsolidadoStatus.propTypes = {
    date: PropTypes.string,
}

export default ResumoConsolidadoStatus